import React, { Component } from 'react'
import {
    Container, Table, Button,
    Modal, ModalHeader, ModalBody, ModalFooter, Input,
    InputGroup, Alert
} from 'reactstrap'
import Usuario from '../../utilitarios/usuario'
import './adminUsuarios.css'

const usuario = new Usuario

export default class AdminUsuarios extends Component {
    constructor(props) {
        super(props)

        this.state = {
            user: null,
            usuarios: [],
            modalPuntos: false,
            nuevoPuntaje: 0,
            usuarioBuscar: '',
            sumarPuntos: true,
            guardando: false,
            error: null
        }
        this.onChangeSearch = this.onChangeSearch.bind(this)
        this.buscarUsuario = this.buscarUsuario.bind(this)
        this.updatePuntaje = this.updatePuntaje.bind(this)
        this.cargarPuntos = this.cargarPuntos.bind(this)
        this.guardarPuntos = this.guardarPuntos.bind(this)
        this.leerUsuarios = this.leerUsuarios.bind(this)
        this.toggle = this.toggle.bind(this)
        this.cancelarModalPuntos = this.cancelarModalPuntos.bind(this)
        this.guardarSuccess= this.guardarSuccess.bind(this)
        this.guardarError= this.guardarError.bind(this)
    }

    cancelarModalPuntos(e){
        this.setState({
            error: null,
            modalPuntos: false
        })
    }

    onChangeSearch(e) {
        this.setState({
            usuarioBuscar: e.target.value
        })
    }

    buscarUsuario() {
        const _this = this
        usuario.buscarUsuario(this.state.usuarioBuscar)
            .then(usuarios => _this.setState({ usuarios }))
    }

    updatePuntaje(e) {
        this.setState({
            nuevoPuntaje: e.target.value
        })
    }

    cargarPuntos(e) {
        const _this = this
        let { sumarPuntos } = this.state
        if (e.target.name == 'restar') {
            sumarPuntos = false
        }else if(e.target.name == 'sumar'){
            sumarPuntos = true
        }
        usuario.leerUsuario(e.target.id).then(user => {
            _this.setState({
                user,
                sumarPuntos,
                modalPuntos: true
            })
        })
    }

    guardarPuntos(e) {
        const _this = this
        const nuevoPuntaje = Math.abs(this.state.nuevoPuntaje)

        this.setState({guardando: true})

        if (e.target.name == 'sumar') {
            usuario.sumarPuntos(this.state.user, nuevoPuntaje)
            .then(_this.guardarSuccess)
            .catch(error => _this.guardarError(error))
        } else if (e.target.name == 'restar') {
            usuario.restarPuntos(this.state.user, nuevoPuntaje)
                .then(_this.guardarSuccess)
                .catch(error => _this.guardarError(error))
        }
    }

    guardarSuccess(){
        this.setState({
            user: null,
            modalPuntos: false,
            guardando: false,
            error: null
        })
        this.leerUsuarios()
    }

    guardarError(error){
        this.setState({
            modalPuntos: true,
            guardando: false,
            error: error.message
        })
    }

    toggle() {
        this.setState(prevState => ({
            modalPuntos: !prevState.modalPuntos
        }));
    }

    leerUsuarios() {
        const _this = this
        usuario.getUsers().then(usuarios => {
            _this.setState({ usuarios })
        })
    }

    componentDidMount() {
        this.leerUsuarios()
    }

    render() {

        return (
            <Container className="UsuariosAdmin">
                <h2>Administracion de usuarios</h2>
                <div className="UsuariosAdminBody">
                    <InputGroup className="InputBuscarUsuarios" >
                        <Input onChange={this.onChangeSearch} placeholder="Buscar..." />
                        <Button color="dark" onClick={this.buscarUsuario}>Buscar</Button>
                    </InputGroup>
                    <div className="TablaUsuarios">
                        <Table>
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Correo</th>
                                    <th>Puntos</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.usuarios.map(item =>
                                        <tr key={item.data().uid}>
                                            <th scope="row">{item.data().Nombre}</th>
                                            <td>{item.data().Correo}</td>
                                            <td>{item.data().Puntos}</td>
                                            <td>
                                                <Button id={item.data().uid} color="warning" name="sumar" onClick={this.cargarPuntos}>Añadir puntos</Button>{' '}
                                                <Button id={item.data().uid} color="danger" name="restar" onClick={this.cargarPuntos}>Restar puntos</Button>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>


                <Modal isOpen={this.state.modalPuntos} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>{this.state.user && this.state.user.Nombre}</ModalHeader>
                    <ModalBody>
                        <Input type="number" id="nuevoPuntaje" onChange={this.updatePuntaje} placeholder={this.state.sumarPuntos ? 'Añadir puntos' : 'Restar puntos'} />
                        {
                            this.state.error && <Alert color="danger">Error: {this.state.error}</Alert>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color="warning" name={this.state.sumarPuntos ? 'sumar' : 'restar'} onClick={this.guardarPuntos} disabled={this.state.guardando}>Aplicar</Button>{' '}
                        <Button color="secondary" onClick={this.cancelarModalPuntos}>Cancelar</Button>
                    </ModalFooter>
                </Modal>
            </Container>
        )
    }

}